export const selShirt = async ({ dispatch, productData, toDataURL, data }) => {
	await dispatch(
		productData({
			hello: {},
			shirt: {},
			shirtsdata1: "",
			shirtsdata2: "",
		}),
	);

	await dispatch(
		productData({
			hello: data,
			seldata: true,
			shirt: {
				frontshirturl: data.frontImg,
				backshirturl: data.backImg,
			},
		}),
	);

	await toDataURL(data.frontImg, async function (myBase64) {
		dispatch(
			productData({
				shirtsdata1: myBase64.replace(
					"data:binary/octet-stream;base64,",
					"data:image/png;base64,",
				),
			}),
		);
	});
	await toDataURL(data.backImg, async function (myBase64) {
		dispatch(
			productData({
				shirtsdata2: myBase64.replace(
					"data:binary/octet-stream;base64,",
					"data:image/png;base64,",
				),
			}),
		);
	});
};

export const productCategory = async (
	API,
	graphql,
	listProductCategorys,
	setProdCat,
) => {
	let nextToken = null;
	let items = [];
	try {
		do {
			const products = await API.graphql({
				query: listProductCategorys,
				authMode: "API_KEY",
			});
			items = items.concat(
				products.data.listProductCategorys.items.sort(
					(a, b) =>
						new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
				),
			);
			nextToken = products.data.listProductCategorys.nextToken;
		} while (nextToken);
		setProdCat(items);
	} catch (e) {
		console.log(e);
	}
};
